/// <amd-module name="Repos/Views/PullRequest/Discussion/PullRequestDiscussionUtil" />
import { GitPullRequestCommentThread } from "Repos/Common/Contracts/Git";
import { DiscussionThreadModel, IDiscussionThreadModelProps, newThread } from "Repos/Discussion/DiscussionThread";
import { newGuid } from "VSS/Core/Util/String";
import { IGitPullRequestCommentThreadModel } from "./PullRequestDiscussionThreadService";

export function newPullRequestThreadModel(props?: IDiscussionThreadModelProps): IGitPullRequestCommentThreadModel {
    const thread = newThread() as GitPullRequestCommentThread;

    thread.properties = {
        "Microsoft.TeamFoundation.Discussion.SupportsMarkdown": { type: "System.Int32", value: 1 },
        "Microsoft.TeamFoundation.Discussion.UniqueID": { type: "System.String", value: newGuid() }
    };

    return new DiscussionThreadModel<GitPullRequestCommentThread>({ ...props, thread });
}
